import React from 'react';
import ResponsiveEmbed from 'react-bootstrap/lib/ResponsiveEmbed';

const VideoPlayer = React.createClass({

    render(){
        return (
            <div>
                <ResponsiveEmbed a16by9>
                    <video
                        controls
                        src={`https://cdn.filestackcontent.com/${this.props.videoId}`}
                        poster={`https://cdn.filestackcontent.com/${this.props.videoPosterId}`}
                        type="video/mp4"
                    ></video>
                </ResponsiveEmbed>
            </div>
        );
    }
});


export default VideoPlayer;



/** WEBPACK FOOTER **
 ** ./src/components/Media/VideoPlayer.js
 **/